import type { StepperTabPanelProps } from "@components/StepperTabs/StepperTabs.types.ts";

const StepperTabPanel = ({ children }: StepperTabPanelProps) => {
  return <>{children}</>;
};

export default StepperTabPanel;
